import { NavigateFunction } from 'react-router-dom';
import { IMaintenanceError } from 'core/model/interfaces/error.interface';

export type TMaintenanceErrorHandlerFn = (payload: IMaintenanceError['error']) => void;

export class MaintenanceUtils {
  private static instance: MaintenanceUtils | null = null;
  private navigateFn: NavigateFunction | null = null;
  private maintenanceErrorHandlerFn: TMaintenanceErrorHandlerFn | null = null;
  private maintenanceError: IMaintenanceError['error'] | null = null;

  private constructor() {}

  public static getInstance(): MaintenanceUtils {
    MaintenanceUtils.instance ??= new MaintenanceUtils();
    return MaintenanceUtils.instance;
  }

  public setNavigate(navigate: NavigateFunction): void {
    this.navigateFn = navigate;
  }

  public getNavigate(): NavigateFunction | null {
    return this.navigateFn;
  }

  public setMaintenanceErrorHandler(handler: TMaintenanceErrorHandlerFn): void {
    this.maintenanceErrorHandlerFn = handler;
  }

  public getMaintenanceErrorHandler(): TMaintenanceErrorHandlerFn | null {
    return this.maintenanceErrorHandlerFn;
  }

  public setMaintenanceError(error: IMaintenanceError['error'] | null): void {
    this.maintenanceError = error;
  }

  public getMaintenanceError(): IMaintenanceError['error'] | null {
    return this.maintenanceError;
  }
}

export const setNavigate = (navigate: NavigateFunction) => {
  MaintenanceUtils.getInstance().setNavigate(navigate);
};
export const getNavigate = () => MaintenanceUtils.getInstance().getNavigate();

export const setMaintenanceErrorHandler = (handler: TMaintenanceErrorHandlerFn) => {
  MaintenanceUtils.getInstance().setMaintenanceErrorHandler(handler);
};
export const getMaintenanceErrorHandler = () => MaintenanceUtils.getInstance().getMaintenanceErrorHandler();

export const setMaintenanceError = (error: IMaintenanceError['error'] | null) => {
  MaintenanceUtils.getInstance().setMaintenanceError(error);
};
export const getMaintenanceError = () => MaintenanceUtils.getInstance().getMaintenanceError();

export default MaintenanceUtils;
